'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var hasRequiredFeatures = exports.hasRequiredFeatures = function hasRequiredFeatures(window) {
  if (typeof window.requestAnimationFrame !== 'function') {
    return false;
  }

  if (typeof window.WeakMap !== 'function') {
    return false;
  }

  if (typeof window.Promise.all !== 'function') {
    return false;
  }

  if (typeof window.Promise.resolve !== 'function') {
    return false;
  }

  return true;
};